
<div class="mb">
  <h2 class="h3 mb-0">Edit custom item</h2>
  <a target="_blank" class="text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/wiki/Contributing:-Spirit-trees">Help</a>
</div>

<form [formGroup]="form" style="min-width: 300px;" (ngSubmit)="save()">
  <div>
    <label for="name">Item name</label>
    <input id="name" formControlName="name" class="" placeholder="Name">
    @if (form.get('name')?.hasError('required')) {
      <span class="c-warn-accent">Name is required</span>
    }
  </div>
  <div>
    <label for="type">Item type</label>
    <select id="type" formControlName="type" class="">
      @for (type of typeOptions; track $index) {
        <option [value]="type">{{ type | itemType }}</option>
      }
    </select>
    @if (form.get('type')?.hasError('required')) {
      <span class="c-warn-accent">Type is required</span>
    }
  </div>
  @if (form.get('type')?.value === typeEmote) {
    <div>
      <label for="level">Emote level</label>
      <div>
        <label><input type="radio" formControlName="level" value="1" />1</label>
        <label><input type="radio" formControlName="level" value="2" />2</label>
        <label><input type="radio" formControlName="level" value="3" />3</label>
        <label><input type="radio" formControlName="level" value="4" />4</label>
      </div>
    </div>
  }
  <div>
    <label for="subtype">Item subtype</label>
    <select id="subtype" formControlName="subtype" class="">
      @for (subtype of subtypeOptions; track $index) {
        <option [value]="subtype">{{ subtype }}</option>
      }
    </select>
  </div>
  <div>
    <label for="group">Item group</label>
    <select id="group" formControlName="group" class="">
      @for (group of groupOptions; track $index) {
        <option [value]="group">{{ group }}</option>
      }
    </select>
  </div>
  <div>
    <label for="icon">Icon link</label>
    <input id="icon" formControlName="icon" class=""/>
  </div>
  <div>
    <label for="previewUrl">Preview image link</label>
    <input id="previewUrl" formControlName="previewUrl" class=""/>
  </div>
  <div>
    <label for="description">Dye slots</label>
    <div>
      <label><input type="radio" formControlName="dyes" value="0" />0</label>
      <label><input type="radio" formControlName="dyes" value="1" />1</label>
      <label><input type="radio" formControlName="dyes" value="2" />2</label>
    </div>
  </div>
  <div class="mt">
    <button type="button" class="button-danger" (click)="cancel()">Cancel</button>
    <button type="submit" class="float-right">Save</button>
  </div>
</form>
